import Achievements from './Achievements.vue'

export default Achievements
